<template>
  <li v-if="user.company" class="mktp-menu dropdown" :class="{ 'active': routeName.startsWith('mktp_')}">
    <router-link :to="{name: 'mktp_home'}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      Pedidos<span v-if="mktp_orders > 0" class="bell-badge">{{ mktp_orders }}</span>
    </router-link>
  </li>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'MktpMenu',
    components: {},
    data () {
      return {
        mktp_orders: 0
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {},
    methods: {
      ...mapActions([])
    }
  }
</script>


// WEBPACK FOOTER //
// MktpMenu.vue?3c637bd6